import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { throttle } from 'throttle-debounce';

/** Решает задачу синхронизации ширин колонок в двух отдельных css-grid элементах */
export const useObserveColumnsWidths = () => {
  const [widths, setWidths] = React.useState<null | number[]>(null);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const rowRef = React.useRef<HTMLDivElement>(null);

  /** При изменении размеров ячеек сохранит ширины в стейт */
  const ro = React.useMemo(
    () =>
      new ResizeObserver(
        throttle(200, () => {
          if (rowRef.current) {
            const columns = rowRef.current.children;
            const widths = calculateColumnsWidths(columns);
            setWidths(widths);
          }
        }),
      ),
    [],
  );

  /** Следит за изменением размеров контейнера (при этом будут меняться ширины ячеек) */
  React.useEffect(() => {
    const div = containerRef.current as HTMLDivElement;

    ro.observe(div);

    return () => ro.disconnect();
  }, [ro]);

  return { widths, containerRef, rowRef };
};

function calculateColumnsWidths(columns: HTMLCollection) {
  return Array.from(columns).map(col => col.getBoundingClientRect().width);
}
